import React from "react";
import styles from "./ProgramOverview.module.css";
import { CircleCheck } from "lucide-react";

interface ProgramOverviewProps {
  data?: {
    title_description?: {
      title?: string;
      description?: string;
    };
    requirement_list?: {
      title?: string;
      items?: { item: string }[];
    };
    list_items?: {
      title?: string;
      description?: string;
    }[];
  };
}

const ProgramOverview: React.FC<ProgramOverviewProps> = ({ data }) => {
  if (!data) return <div>No program data available.</div>;

  // Use default if list_items is missing or empty
  const listItems = data.list_items?.length ? data.list_items : [];

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>
        {data?.title_description?.title || "Program Overview"}
      </h2>
      <p className={`${styles.description} more-content`}>
        {data?.title_description?.description || ""}
      </p>

      {/* Responsive grid for list_items */}
      <div className={styles.gridList}>
        {listItems.map((item, idx) => (
          <div className={styles.gridItem} key={idx}>
            <CircleCheck className={styles.icon} />
            <div className={styles.gridItemContent}>
              <span className={styles.gridTitle}>{item.title} </span>
              <span className={styles.gridDesc}>{item.description}</span>
            </div>
          </div>
        ))}
      </div>

      <h3 className={styles.requirementsTitle}>
        {data?.requirement_list?.title || "Admission Requirements"}
      </h3>
      <ul className={styles.requirementsList}>
        {data?.requirement_list?.items?.map((requirement, index) => (
          <li key={index} className={styles.requirementItem}>
            <span className={styles.icon}>
              <CircleCheck />
            </span>
            <span>{requirement?.item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ProgramOverview;
